import { useTheme } from 'styled-components';
import * as Styled from './PricingIndicatorIconText.styled';
import { Text } from '../../ToolkitV2/Text/Text';
import type { PricingIndicatorIconTextProps } from './PricingIndicatorIconText.typed';

import {
  ArrowDownCircleIc,
  ArrowForwardCircleIc,
  ArrowUpCircleIc,
} from '@dsch/dd-icons';

const PricingIndicatorIconText = (props: PricingIndicatorIconTextProps) => {
  const { status, underline, textSize = 'B14', onClick } = props;
  const theme = useTheme();

  const statusStates = {
    ABOVE: {
      label: 'Above avg.',
      icon: (
        <ArrowUpCircleIc
          color={theme.donedeal.colors.GREY}
          width="16"
          height="16"
        />
      ),
    },
    SAME: {
      label: 'At avg.',
      icon: (
        <ArrowForwardCircleIc
          color={theme.donedeal.colors.ORANGE_LIGHT}
          width="16"
          height="16"
        />
      ),
    },
    BELOW: {
      label: 'Below avg.',
      icon: (
        <ArrowDownCircleIc
          color={theme.donedeal.colors.GREEN}
          width="16"
          height="16"
        />
      ),
    },
  } as const;

  const state = statusStates[status];

  if (!state) return null;

  const { label, icon } = state;

  if (onClick) {
    return (
      <Styled.TriggerContainer onClick={onClick}>
        {icon}
        <Styled.TriggerText
          size={textSize}
          forwardedAs="span"
          color={'GREY_DARK'}
          weight="regular"
        >
          {label}
        </Styled.TriggerText>
      </Styled.TriggerContainer>
    );
  }

  return (
    <Styled.Container>
      <Styled.IconWrapper aria-hidden="true">{icon}</Styled.IconWrapper>
      <Text
        size={textSize}
        forwardedAs="span"
        color={'GREY_DARK'}
        underline={underline ? 'dotted' : false}
      >
        {label}
      </Text>
    </Styled.Container>
  );
};

export { PricingIndicatorIconText };
